import { useContext, useState, useEffect, useMemo, useCallback, useRef } from "react";
import { DiscoveryContext } from "../discovery-context";
import {
    transformFunnelData,
} from "../../../utils/helpers";
import {
    getConversationTables,
    OVERVIEW_LLM_LABELS
} from "../../../utils/constant";
import classes from "./Conversations.module.css";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import { filterKey } from "../BrandAudit";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import Modal from "../../../Component/Modal/Modal";
import Share from "../Share/Share";
import { Box, Button, Typography, Chip, CircularProgress } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { faDownload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Checkbox from "@mui/material/Checkbox";
import { tab } from "../BrandScore/BrandScore";
import TableWrapper from "./TableWrapper";
import ConversationForm from "./ConversationForm";
import api from "../../../BrandOnBoarding/api";
import ConversationHistory from "./ConversationHistory";
import { toast } from "react-toastify";
import PdfFilterModal from "../../../luminaire/Conversations/PdfFilterModal";
import { getEntityLabel } from "../../../utils/labelMapping";
import { useDailyLimits } from "../../../hooks/useDailyLimits";

const Conversations = () => {
    const discoveryCtx = useContext(DiscoveryContext);
    const [showShareModal, setShowShareModal] = useState(false);
    const [conversationsData, setConversationsData] = useState({})
    const [showConversationModal, setShowConversationModal] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [generateError, setGenerateError] = useState(null);
    const [showPdfFilterModal, setShowPdfFilterModal] = useState(false);
    const [pdfFilterOption, setPdfFilterOption] = useState('');
    const [tableFilter, setTableFilter] = useState('brand');
    const [activeConversationId, setActiveConversationId] = useState('default');
    const [noConversationRecords, setNoConversationRecords] = useState(false);
    // Always start with loading=true to prevent flicker of old context data
    const [loading, setLoading] = useState(true);
    const [conversationSelection, setConversationSelection] = useState(() => ({
        llm: discoveryCtx.primary_llm,
        market: discoveryCtx.market,
        persona: discoveryCtx.persona?.[0],
        created_at: null,
    }));
    const {
        launchText,
    } = useDailyLimits("BrandAudit");
    const primaryLLM = discoveryCtx.primary_llm;
    const category = discoveryCtx.category;
    const primaryPersona = discoveryCtx.persona[0]?.title;
    const selectedCategory = discoveryCtx.state.selectedCategory;
    const primaryMarket = discoveryCtx.market;
    const discoveryType = discoveryCtx.type || "brand";
    const primaryCategory = discoveryCtx.category?.[0];
    const isPrimaryCategory = selectedCategory === primaryCategory;
    const type = discoveryCtx.type[0].toUpperCase() + discoveryCtx.type.slice(1);
    const webSocketBaseURL = process.env.REACT_APP_ORCHESTRATOR_BASE_URL;
    const MAX_LAUNCHES = discoveryCtx.auditLimits?.conversation_limits || 5;
    const remainingLaunches = discoveryCtx.auditLimits?.conversation_limits_remaining ?? MAX_LAUNCHES;
    const pdfRef = useRef();
    const requestIdCacheRef = useRef({});
    const transactionId = discoveryCtx?.state?.transactionId;
    const isFinalTransactionCompleted = discoveryCtx?.state.finalTransactionStatus === "COMPLETED";

    const pollingIntervalRef = useRef(null);
    // ── Helper: stop any active polling interval ──────────────────────────────
    const stopPolling = useCallback(() => {
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
    }, []);

    // ── Helper: start polling for a specific conversation ID ──────────────────
    const startPollingForConversation = useCallback((conversationId, persona, category, request_id, created_at) => {
        stopPolling();

        console.log(`Starting polling for conversation ${conversationId}...`);

        pollingIntervalRef.current = setInterval(async () => {
            try {
                const result = await api.get(`${webSocketBaseURL}/conversation/${conversationId}`);
                console.log("pollingdata", result, conversationId, persona, category, request_id, created_at)
                // Still running — keep waiting, next interval will check again
                if (result?.data?.status && result.data.status !== 'COMPLETED') {
                    console.log(`Conversation ${conversationId} still RUNNING...`);
                    return;
                }

                discoveryCtx.updateConversations({
                    data: result?.data?.data || result?.data || {},
                    category: category || selectedCategory,
                    llm: primaryLLM,
                    market: primaryMarket,
                    persona: persona,
                    request_id: request_id,
                    created_at: created_at,
                    conversation_id: conversationId,
                    conversationStatus: 'COMPLETED',
                });

                // Stop polling — no longer needed
                stopPolling();

                // Turn off loading — conversationNode watcher will render the data
                setLoading(false);

            } catch (error) {
                console.error(`Polling error for conversation ${conversationId}:`, error);
                stopPolling();
                setLoading(false);
            }
        }, 60000); // 1 minute interval — lightweight, avoids hammering the server
    }, [discoveryCtx, primaryLLM, primaryMarket, selectedCategory, webSocketBaseURL, stopPolling]);
    console.log("requestIdCacheRef",requestIdCacheRef)
    useEffect(() => {
        const fetchAndSelectLatest = async () => {
            try {
                let existingConversations = discoveryCtx.conversations?.[primaryLLM]?.[selectedCategory]?.[primaryMarket]?.[primaryPersona];

             if (!existingConversations || Object.keys(existingConversations).length === 0) {
                 const allPersonas = discoveryCtx.conversations?.[primaryLLM]?.[selectedCategory]?.[primaryMarket] || {};
                 const fallbackPersona = Object.keys(allPersonas).find(
                     persona => persona !== primaryPersona && Object.keys(allPersonas[persona] || {}).length > 0
                 );
                 if (fallbackPersona) {
                     existingConversations = allPersonas[fallbackPersona];
                 }
             }
             
             let requestId = null;
             if (existingConversations && Object.keys(existingConversations).length > 0) {
                 const order = existingConversations['_order'];
                 const firstKey = order?.[0];
                 const firstConversation = firstKey ? existingConversations[firstKey] : Object.values(existingConversations)[0];
                 requestId = firstConversation?.request_id;
}

                if (!transactionId || !requestId) {
                    return;
                }
                const cacheKey = `${primaryLLM}__${selectedCategory}__${primaryMarket}__${primaryPersona}`;
                if (requestId) {
                    requestIdCacheRef.current[cacheKey] = requestId;
                }
                const result = await api.get(`${webSocketBaseURL}/conversation/${transactionId}/${requestId}`);
                const historyData = result?.data || [];

                if (historyData.length === 0) {
                    setNoConversationRecords(true);
                    return;
                }

                // API returns DESC order, so first item is latest
                const latestRecord = historyData[0];
                const latestId = latestRecord?.id;
                console.log("latestRecord", latestRecord)
                if (!latestId) {
                    return;
                }
                if (latestRecord?.status === 'RUNNING') {
                    setLoading(true);
                    startPollingForConversation(latestId, latestRecord?.persona, selectedCategory, latestRecord.request_id, latestRecord.created_at)
                }

                setActiveConversationId(latestId);
                setConversationSelection(prev => ({
                    ...prev,
                    persona: latestRecord.persona,
                    created_at: latestRecord.created_at
                }));

            } catch (error) {
                console.error("Failed to auto-select latest conversation", error);
            }
        };

        fetchAndSelectLatest();
    }, [discoveryCtx.formData, selectedCategory]);
console.log("loadingData",loading,noConversationRecords,pollingIntervalRef)


    // ── Cleanup on unmount — always stop polling when component leaves DOM ────
    useEffect(() => {
        return () => {
            stopPolling();
        };
    }, [stopPolling]);

    const conversationNode = useMemo(() => {
        const persona = conversationSelection?.persona?.title || conversationSelection?.persona;
        if (!persona || !selectedCategory) return null;

        const conversationsMap = discoveryCtx.conversations?.[primaryLLM]?.[selectedCategory]?.[primaryMarket]?.[persona] || {};
        if (!conversationsMap || Object.keys(conversationsMap).length === 0) {
            return null;
        }
        if (activeConversationId === 'default') {
            const keys = Object.keys(conversationsMap).filter(k => k !== '_order');
            const lastKey = keys[keys.length - 1];
            return lastKey ? conversationsMap[lastKey] : null;
        }
        return conversationsMap[activeConversationId];

    }, [
        discoveryCtx.conversations,
        conversationSelection?.persona,
        selectedCategory,
        primaryLLM,
        primaryMarket,
        activeConversationId,
    ]);

    const brandConversationData = useMemo(() => {
        const brandConversations = discoveryCtx.conversations?.[primaryLLM]?.[primaryCategory]?.[primaryMarket]?.[primaryPersona];
        if (!brandConversations || Object.keys(brandConversations).length === 0) {
            return null;
        }

        return brandConversations['default']?.data;
    }, [
        discoveryCtx.conversations,
        primaryLLM,
        primaryCategory,
        primaryMarket,
        primaryPersona
    ]);

    useEffect(() => {
        if (conversationNode?.data && Object.keys(conversationNode.data).length > 0) {
            setNoConversationRecords(false)
            setLoading(false);
            setConversationsData(conversationNode?.data || null);
            setConversationSelection(prev => ({
                ...prev,
                created_at: conversationNode?.created_at
            }));
        } else if (!conversationNode && !loading) {
        setNoConversationRecords(true);
    }
    }, [conversationNode, loading]);

    // useEffect(() => {
    //     stopPolling();
    // }, [activeConversationId]);

    let requestId = conversationNode?.request_id;
    if (!requestId) {
        const cacheKey = `${primaryLLM}__${selectedCategory}__${primaryMarket}__${primaryPersona}`;
        requestId = requestIdCacheRef.current[cacheKey] ?? null;
    }

    const hasConversationsData = useMemo(() => {
        return !!(
            conversationsData &&
            Object.keys(conversationsData).length > 0
        );
    }, [conversationsData]);

    // Called from ConversationHistory after a deletion to handle auto-select or empty state
    const handleAfterDelete = useCallback(async (remainingHistoryData, deletedConversationId, deletedItem) => {
        stopPolling();

        if (deletedConversationId && deletedItem) {
            discoveryCtx.deleteConversations({
                llm: primaryLLM,
                category: deletedItem.category || primaryCategory,
                market: deletedItem.market || primaryMarket,
                persona: deletedItem.persona || primaryPersona,
                conversation_id: deletedConversationId,
            });
        }

        if (!remainingHistoryData || remainingHistoryData.length === 0) {
            setNoConversationRecords(true);
            setConversationsData({});
            setActiveConversationId('default');
            setLoading(false);
            return;
        }

        const nextLatest = remainingHistoryData[0];
        const nextId = nextLatest?.id;

        if (!nextId) return;

        setNoConversationRecords(false);

        const existingConversations = discoveryCtx.conversations?.[primaryLLM]?.[nextLatest.category || primaryCategory]?.[primaryMarket]?.[nextLatest.persona || primaryPersona];
        const existingData = existingConversations?.[nextId]?.data;

        if (existingData && Object.keys(existingData).length > 0) {
            setActiveConversationId(nextId);
            setConversationSelection(prev => ({
                ...prev,
                persona: nextLatest.persona,
                created_at: nextLatest.created_at
            }));
            return;
        }

        try {
            setLoading(true);
            const result = await api.get(`${webSocketBaseURL}/conversation/${nextId}`);
            discoveryCtx.updateConversations({
                data: result?.data?.data || result?.data || {},
                category: nextLatest.category || primaryCategory,
                llm: primaryLLM,
                market: primaryMarket,
                persona: nextLatest.persona || primaryPersona,
                request_id: nextLatest.request_id,
                created_at: nextLatest.created_at,
                conversation_id: nextId,
                conversationStatus: result?.data?.status || 'COMPLETED',
            });
            setActiveConversationId(nextId);
            setConversationSelection(prev => ({
                ...prev,
                persona: nextLatest.persona,
                created_at: nextLatest.created_at
            }));
        } catch (error) {
            console.error("Failed to load next conversation after deletion", error);
        } finally {
            setLoading(false);
        }
    }, [discoveryCtx, primaryLLM, primaryCategory, primaryMarket, primaryPersona, webSocketBaseURL, stopPolling]);

    const tablesConfig = [
        // Brand Discussion Topics
        {
            id: "Brand_Discussion_Topics",
            title: `${type} Discussion Topics`,
            data: conversationsData?.discussionTopics?.entity_discussion_topics,
            sources:
                conversationsData?.discussionTopics
                    ?.entity_discussion_topics_sources,
            rawData:
                conversationsData?.rawData?.discussionTopics?.entity?.results,
            rawSearchData: conversationsData?.discussionTopics?.entityRawSearch,
            isBrandTable: true,
        },

        // Category Discussion Topics
        {
            id: "Category_Discussion_Topics",
            title: "Category Discussion Topics",
            data: conversationsData?.discussionTopics?.discussion_topics,
            sources:
                conversationsData?.discussionTopics?.discussion_topics_sources,
            rawData:
                conversationsData?.rawData?.discussionTopics?.category?.results,
            rawSearchData: conversationsData?.discussionTopics?.categoryRawSearch,
            isBrandTable: false,
        },

        // Brand Key Questions
        {
            id: "Brand_Key_Questions",
            title: `${type} Key Questions`,
            data: conversationsData?.keyQuestions?.entity_key_questions,
            sources:
                conversationsData?.keyQuestions?.entity_key_question_sources,
            rawData:
                conversationsData?.rawData?.keyQuestions?.entity?.results,
            rawSearchData: conversationsData?.keyQuestions?.entityRawSearch,
            isBrandTable: true,
        },

        // Category Key Questions
        {
            id: "Category_Key_Questions",
            title: "Category Key Questions",
            data: conversationsData?.keyQuestions?.key_questions,
            sources:
                conversationsData?.keyQuestions?.key_question_sources,
            rawData:
                conversationsData?.rawData?.keyQuestions?.category?.results,
            rawSearchData: conversationsData?.keyQuestions?.categoryRawSearch,
            isBrandTable: false,
        },

        // Brand Purchase Barriers
        {
            id: "Brand_Purchase_Barriers",
            title: `${type} Purchase Barriers`,
            data: conversationsData?.purchaseBarriers?.entity_data,
            sources:
                conversationsData?.purchaseBarriers?.entity_data_sources,
            rawData:
                conversationsData?.rawData?.purchaseBarriers?.entity?.results,
            rawSearchData: conversationsData?.purchaseBarriers?.entityRawSearch,
            isBrandTable: true,
        },

        // Category Purchase Barriers
        {
            id: "Category_Purchase_Barriers",
            title: "Category Purchase Barriers",
            data: conversationsData?.purchaseBarriers?.category_data,
            sources:
                conversationsData?.purchaseBarriers?.category_data_sources,
            rawData:
                conversationsData?.rawData?.purchaseBarriers?.category?.results,
            rawSearchData: conversationsData?.purchaseBarriers?.categoryRawSearch,
            isBrandTable: false,
        },

        // Brand Purchase Enablers
        {
            id: "Brand_Purchase_Enablers",
            title: `${type} Purchase Enablers`,
            data: conversationsData?.purchaseEnablers?.entity_data,
            sources:
                conversationsData?.purchaseEnablers?.entity_data_sources,
            rawData:
                conversationsData?.rawData?.purchaseEnablers?.entity?.results,
            rawSearchData: conversationsData?.purchaseEnablers?.entityRawSearch,
            isBrandTable: true,
        },

        // Category Purchase Enablers
        {
            id: "Category_Purchase_Enablers",
            title: "Category Purchase Enablers",
            data: conversationsData?.purchaseEnablers?.category_data,
            sources:
                conversationsData?.purchaseEnablers?.category_data_sources,
            rawData:
                conversationsData?.rawData?.purchaseEnablers?.category?.results,
            rawSearchData: conversationsData?.purchaseEnablers?.categoryRawSearch,
            isBrandTable: false,
        },

        // Brand Customer Needs
        {
            id: "Brand_Customer_Needs",
            title: `${type} Customer Needs`,
            data: conversationsData?.customerNeeds?.entity_customer_needs,
            sources:
                conversationsData?.customerNeeds
                    ?.entity_customer_needs_sources,
            rawData:
                conversationsData?.rawData?.customerNeeds?.entity?.results,
            rawSearchData: conversationsData?.customerNeeds?.entityRawSearch,
            isBrandTable: true,
        },

        // Category Customer Needs
        {
            id: "Category_Customer_Needs",
            title: "Category Customer Needs",
            data: conversationsData?.customerNeeds?.customer_needs,
            sources:
                conversationsData?.customerNeeds?.customer_needs_sources,
            rawData:
                conversationsData?.rawData?.customerNeeds?.category?.results,
            rawSearchData: conversationsData?.customerNeeds?.categoryRawSearch,
            isBrandTable: false,
        },

        // Brand Customer Pain Points
        {
            id: "Brand_Customer_Pain_Points",
            title: `${type} Customer Pain Points`,
            data:
                conversationsData?.customerPainPoints
                    ?.entity_customer_pain_points,
            sources:
                conversationsData?.customerPainPoints
                    ?.entity_customer_pain_points_sources,
            rawData:
                conversationsData?.rawData?.customerPainPoints?.entity?.results,
            rawSearchData: conversationsData?.customerPainPoints?.entityRawSearch,
            isBrandTable: true,
        },

        // Category Customer Pain Points
        {
            id: "Category_Customer_Pain_Points",
            title: "Category Customer Pain Points",
            data:
                conversationsData?.customerPainPoints?.customer_pain_points,
            sources:
                conversationsData?.customerPainPoints
                    ?.customer_pain_points_sources,
            rawData:
                conversationsData?.rawData?.customerPainPoints?.category?.results,
            rawSearchData: conversationsData?.customerPainPoints?.categoryRawSearch,
            isBrandTable: false,
        },

        // Brand Emerging Trends
        {
            id: "Brand_Emerging_Trends",
            title: `${type} Emerging Trends`,
            data:
                conversationsData?.customerEmergingTrends
                    ?.entity_emerging_trends,
            sources:
                conversationsData?.customerEmergingTrends
                    ?.entity_emerging_trends_sources,
            rawData:
                conversationsData?.rawData
                    ?.customerEmergingTrends?.entity?.results,
            rawSearchData: conversationsData?.customerEmergingTrends?.entityRawSearch,
            isBrandTable: true,
        },

        // Category Emerging Trends
        {
            id: "Category_Emerging_Trends",
            title: "Category Emerging Trends",
            data:
                conversationsData?.customerEmergingTrends?.emerging_trends,
            sources:
                conversationsData?.customerEmergingTrends
                    ?.emerging_trends_sources,
            rawData:
                conversationsData?.rawData
                    ?.customerEmergingTrends?.category?.results,
            rawSearchData: conversationsData?.customerEmergingTrends?.categoryRawSearch,
            isBrandTable: false,
        },

        //  Brand Customer Complaints
        {
            id: "Brand_Customer_Complaints",
            title: `${type} Customer Complaints`,
            data:
                conversationsData?.customerComplaints
                    ?.entity_customer_complaints,
            sources:
                conversationsData?.customerComplaints
                    ?.entity_customer_complaints_sources,
            rawData:
                conversationsData?.rawData
                    ?.customerComplaints?.entity?.results,
            rawSearchData: conversationsData?.customerComplaints?.entityRawSearch,
            isBrandTable: true,
        },

        // Brand Customer Praises
        {
            id: "Brand_Customer_Praises",
            title: `${type} Customer Praises`,
            data:
                conversationsData?.customerPraises
                    ?.entity_customer_praises,
            sources:
                conversationsData?.customerPraises
                    ?.entity_customer_praises_sources,
            rawData:
                conversationsData?.rawData
                    ?.customerPraises?.entity?.results,
            rawSearchData: conversationsData?.customerPraises?.entityRawSearch,
            isBrandTable: true,
        },

        // Brand Buying Journey Prompts
        {
            id: "Brand_Buying_Journey_Prompts",
            title: `${type} Buying Journey Prompts`,
            data: transformFunnelData(
                conversationsData?.purchaseJourneyQuestions
                    ?.entity_questions?.questions_by_funnel_stage
            ),
            rawSearchData: conversationsData?.purchaseJourneyQuestions?.entityRawSearch,
            isBrandTable: true,
        },
    ];
    const onGenerate = async ({ category, persona, siteSuggestions = [], excludeBrandOwnedSources = false }) => {
        try {
            setLoading(true);
            setNoConversationRecords(false);
            setActiveConversationId(null);
            stopPolling();

            if (launchText) {
                if (remainingLaunches <= 0) return toast.error(`launch limit exhausted.${MAX_LAUNCHES} Maximum limits allowed`)
                discoveryCtx.updateLaunch({
                    conversation_limits_remaining: remainingLaunches - 1
                });
            }
            discoveryCtx.updateSelectedCategory(category);
            // const conversationRecord = discoveryCtx.conversations?.[primaryLLM]?.[category][primaryMarket][primaryPersona] || null;
            const existingConversations = discoveryCtx.conversations?.[primaryLLM]?.[category]?.[primaryMarket]?.[primaryPersona];

            let requestId = null;
            if (existingConversations && Object.keys(existingConversations).length > 0) {
                const firstConversation = Object.values(existingConversations)[0];
                requestId = firstConversation?.request_id;
            }
            if (!requestId) {
             const cacheKey = `${primaryLLM}__${category}__${primaryMarket}__${primaryPersona}`;
             requestId = requestIdCacheRef.current[cacheKey] ?? null;
            }
            setConversationSelection(prev => ({
                ...prev,
                persona,
                created_at: new Date().toISOString()
            }));
            setShowConversationModal(false);
            setGenerateError(null);
            const payload = {
                transaction_id: transactionId,
                request_id: requestId,
                persona,
                category,
                brand: discoveryCtx.entity,
                type: discoveryCtx.type,
                excludeBrandOwnedSources,
                isAdminUSer: !launchText
            };

            if (siteSuggestions && siteSuggestions.length > 0) {
                payload.searchProvider = "grok";
                payload.targetDomains = siteSuggestions;
            }

            const response = await api.post(
                `${webSocketBaseURL}/conversation`,
                payload
            );
            if (!response?.data) {
                throw new Error("Invalid response from server");
            }
            const { conversation, conversation_limits_remaining, id: conversation_id, created_at } = response.data;
            if (launchText) {
                discoveryCtx.updateLaunch({
                    conversation_limits_remaining
                });
            }
            discoveryCtx.updateConversations({
                data: conversation || {},
                category: category,
                llm: primaryLLM,
                market: primaryMarket,
                persona: persona,
                request_id: requestId,
                created_at,
                conversation_id: conversation_id,
                conversationStatus: 'COMPLETED',
            });
            setNoConversationRecords(false);
            setActiveConversationId(conversation_id);
        } catch (error) {
            console.error("Conversation generation failed", error);

            const statusCode = error?.response?.status;
            const errorData = error?.response?.data;

            // if (
            //     statusCode === 409 &&
            //     errorData?.code === "CONVERSATION_ALREADY_EXISTS"
            // ) {
            //      discoveryCtx.updateLaunch({
            //       conversation_limits_remaining: error?.response?.conversation_limits_remaining
            //    });
            //     discoveryCtx.updateConversations({
            //         data: errorData?.data || {},
            //         category: category,
            //         llm: primaryLLM,
            //         market: primaryMarket,
            //         persona: persona,
            //         request_id: requestId
            //     });
            //     toast.info(
            //         errorData.message ||
            //         'Existing conversation loaded.'
            //     );
            //     return;
            // }

            const fallbackMessage =
                errorData?.message ||
                error?.message ||
                "Failed to generate conversation";

            toast.error(fallbackMessage);
            setGenerateError(fallbackMessage);
        } finally {
            setLoading(false);
        }
    };

    const getConversationData = async (data) => {
        const { category, persona, id, request_id, created_at } = data;
        const existingConversations = discoveryCtx.conversations?.[primaryLLM]?.[category]?.[primaryMarket]?.[persona];
        const ConversationData = existingConversations?.[id]?.data;
        setConversationSelection(prev => ({
            ...prev,
            persona,
            created_at
        }));
        if (ConversationData && Object.keys(ConversationData).length > 0) {
            stopPolling();
            setActiveConversationId(id);
            setShowHistoryModal(false);
            setConversationsData(ConversationData);
        } else {
            let isRunning = false;
            try {
                setLoading(true);
                setShowHistoryModal(false);
                stopPolling();

                const result = await api.get(`${webSocketBaseURL}/conversation/${id}`);

                if (result?.data?.status && result.data.status !== 'COMPLETED') {
                    isRunning = true;
                    setNoConversationRecords(false);
                    setConversationsData({});
                    setActiveConversationId(id);
                    startPollingForConversation(id, persona, category, request_id, created_at);
                    return;
                }

                discoveryCtx.updateConversations({
                    data: result?.data?.data || result?.data || {},
                    category: category,
                    llm: primaryLLM,
                    market: primaryMarket,
                    persona: persona,
                    request_id,
                    created_at,
                    conversation_id: id,
                    conversationStatus: 'COMPLETED',
                });
                setActiveConversationId(id);
            } catch (error) {
                console.error("Failed to fetch conversation history", error);
            } finally {
                if (!isRunning) {
                    setLoading(false);
                }
            }
        }
    };

    const CONVERSATION_TABLES = getConversationTables(discoveryType);

    const getConversationUniqueKey = (id) =>
        `${tab[selectedCategory]}_${id}_${primaryLLM}_${primaryMarket}`;

    const tablesForAllSelected = isPrimaryCategory
        ? CONVERSATION_TABLES
        : CONVERSATION_TABLES.filter(({ id }) =>
            id.startsWith("Category_")
        );

    const allSelected = tablesForAllSelected.every(({ id }) =>
        discoveryCtx.state.selectedSection?.[
        getConversationUniqueKey(id)
        ]
    );

    const handleCategoryChange = (e) => {
        const selectedValue = e.target.value;
        // Stop polling when category changes — fetchAndSelectLatest will restart if needed
        stopPolling();
        setActiveConversationId('default');
        discoveryCtx.updateSelectedCategory(selectedValue);
        //  const cacheKey = `${primaryLLM}__${selectedValue}__${primaryMarket}__${primaryPersona}`;
        // if (requestId) {
        //     requestIdCacheRef.current[cacheKey] = requestId;
        // }
        setConversationSelection(prev => ({
            ...prev,
            persona: discoveryCtx.persona?.[0],
        }));
    };

    const toggleConversationSelection = () => {
        const isPrimaryCategory =
            selectedCategory === discoveryCtx.category?.[0];

        const tablesToSelect = isPrimaryCategory
            ? CONVERSATION_TABLES
            : CONVERSATION_TABLES.filter(({ id }) =>
                id.startsWith("Category_")
            );

        const shouldSelectAll = !allSelected;

        tablesToSelect.forEach(({ id, title }) => {
            const uniqueKey = getConversationUniqueKey(id);

            discoveryCtx.clickComponentCheckbox({
                uniqueKey,
                checked: !shouldSelectAll,
                filter: {
                    id,
                    title,
                    tab: tab.conversation,
                    market: primaryMarket,
                    category: selectedCategory,
                    uniqueKey,
                },
            });
        });
    };

    const getFilteredTables = () => {
        if (pdfFilterOption === getEntityLabel(discoveryCtx?.type).toLowerCase()) {
            return tablesConfig.filter(table => table.isBrandTable);
        } else if (pdfFilterOption === 'category') {
            return tablesConfig.filter(table => !table.isBrandTable);
        } else if (pdfFilterOption === 'both') {
            const brandTables = tablesConfig.filter(table => table.isBrandTable);
            const categoryTables = tablesConfig.filter(table => !table.isBrandTable);
            return [...brandTables, ...categoryTables];
        }
        return [];
    };

    const exportToPDF = useReactToPrint({
        contentRef: pdfRef,
        documentTitle: `${discoveryCtx?.entity} Conversations - ${pdfFilterOption.charAt(0).toUpperCase() + pdfFilterOption.slice(1)}`,
        removeAfterPrint: true,
        pageStyle: `
      @page {
        size: A4;
        margin: 10mm;
      }
      
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
        
        * {
          box-sizing: border-box;
        }
        
        /* Prevent page breaks after headers */
        h1, h2, h3, h4, h5, h6 {
          page-break-after: avoid !important;
          break-after: avoid !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          margin: 4px 0 !important;
          padding: 0 !important;
        }
        
        /* Keep header with first table */
        h1 + div,
        div:has(h1) {
          page-break-after: avoid !important;
          break-after: avoid !important;
        }
        
        /* Tables - allow splitting but avoid orphans */
        table {
          page-break-inside: auto;
          break-inside: auto;
          width: 100%;
          border-collapse: collapse;
          margin: 0 !important;
        }
        
        /* Prevent single row orphans */
        tr {
          page-break-inside: avoid;
          break-inside: avoid;
        }
        
        thead {
          display: table-header-group;
        }
        
        /* Cards - compact spacing, avoid breaking if small */
        .MuiCard-root {
          page-break-inside: avoid;
          break-inside: avoid;
          margin: 4px 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          border: 1px solid #e0e0e0 !important;
        }
        
        /* Minimal card content padding */
        .MuiCardContent-root {
          padding: 4px !important;
        }
        
        /* Table container */
        .MuiTableContainer-root {
          box-shadow: none !important;
          margin: 0 !important;
        }
        
        /* Compact table cells */
        .MuiTableCell-root {
          padding: 3px 5px !important;
          font-size: 9px !important;
          line-height: 1.2 !important;
        }
        
        .MuiTableCell-head {
          padding: 5px !important;
          font-size: 10px !important;
          font-weight: 600 !important;
        }
        
        /* Typography compact spacing */
        .MuiTypography-root {
          margin: 3px 0 !important;
          padding: 0 !important;
        }
        
        /* Paragraph spacing */
        p {
          margin: 2px 0 !important;
          orphans: 2;
          widows: 2;
        }
        
        /* Link styling */
        a {
          color: #1976d2;
          text-decoration: none;
          word-break: break-all;
          font-size: 8px !important;
        }
        
        /* Stack spacing */
        .MuiStack-root {
          margin: 0 !important;
          padding: 0 !important;
          gap: 2px !important;
        }
      }
    `,
    });

    const handleDownloadClick = () => {
        setShowPdfFilterModal(true);
    };

    const handlePdfFilterChange = (e) => {
        setPdfFilterOption(e.target.value);
    };

    const handlePdfModalClose = () => {
        setShowPdfFilterModal(false);
        setPdfFilterOption('');
    };

    const handlePdfDownload = () => {
        setShowPdfFilterModal(false);
        setTimeout(() => {
            exportToPDF();
        }, 100);
    };

    const getLimitBadgeColor = () => {
        if (remainingLaunches > 2) return 'success';
        if (remainingLaunches > 0) return 'warning';
        return 'error';
    };

    const getLimitBadgeIcon = () => {
        if (remainingLaunches > 2) return '🎯';
        if (remainingLaunches > 0) return '⚠️';
        return '🚫';
    };

    const pdfFilterOptions = [
        { name: `${getEntityLabel(discoveryCtx?.type)} Tables Only`, value: getEntityLabel(discoveryCtx?.type).toLowerCase() },
        { name: 'Category Tables Only', value: 'category' },
        { name: `Both ${getEntityLabel(discoveryCtx?.type)} and Category`, value: 'both' }
    ];

    const entityLabel = getEntityLabel(discoveryCtx?.type);
    const tableFilterOptions = [
        { name: entityLabel, value: 'brand' },
        { name: 'Category', value: 'category' },
        { name: 'Both', value: 'both' },
    ];

    const displayedTables = useMemo(() => {
        if (tableFilter === 'brand') return tablesConfig.filter(t => t.isBrandTable);
        if (tableFilter === 'category') return tablesConfig.filter(t => !t.isBrandTable);
        return tablesConfig;
    }, [tableFilter, tablesConfig]);

    const formatDateTime = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        return date.toLocaleString(undefined, {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };


    return (
        <>
            <div className={classes.containerWrapper}>
                <div className={classes.topSection}>
                    <div className={classes.topRow}>
                        <div className={classes.titleWrapper}>
                            <h2 className={classes.title}>Conversations</h2>
                            {!noConversationRecords &&
                            <div className={classes.metaInfo}>
                                <span>{conversationSelection?.market}</span>
                                <span>•</span>
                                <span>{conversationSelection?.persona?.title || conversationSelection?.persona}</span>
                                {conversationSelection?.created_at && (
                                    <>
                                        <span>•</span>
                                        <span>Created: {formatDateTime(conversationSelection?.created_at)}</span>
                                    </>
                                )}
                            </div>
                           }
                        </div>

                        <div className={classes.topActions}>
                            <MUISelect
                                fullWidth={false}
                                optionValue={selectedCategory}
                                label="Category"
                                id={filterKey.category}
                                options={(discoveryCtx.category || []).map(cat => ({ name: cat, value: cat }))}
                                onChange={handleCategoryChange}
                            />
                            <MUISelect
                                fullWidth={false}
                                optionValue={tableFilter}
                                label="Show Conversations For"
                                id="tableFilter"
                                options={tableFilterOptions}
                                onChange={(e) => setTableFilter(e.target.value)}
                            />
                            <div className={classes.wrapperBtn}>
                                <MUIIconButton
                                    title="Click to Share"
                                    onClick={() => setShowShareModal(true)}
                                >
                                    <ShareOutlinedIcon color="primary" />
                                </MUIIconButton>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.bottomRow}>
                    {launchText &&
                        <Chip
                            icon={<span style={{ fontSize: '16px' }}>{getLimitBadgeIcon()}</span>}
                            label={
                                remainingLaunches > 1
                                    ? `${remainingLaunches} of ${MAX_LAUNCHES} launches remaining`
                                    : remainingLaunches === 1
                                        ? `${remainingLaunches} launch remaining`
                                        : 'No launches remaining'
                            }
                            color={getLimitBadgeColor()}
                            sx={{
                                fontWeight: 500,
                                fontSize: '13px',
                                height: '32px',
                                marginRight: '12px',
                                '& .MuiChip-icon': {
                                    fontSize: '16px',
                                    marginLeft: '8px'
                                }
                            }}
                        />
                    }
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<span style={{ fontSize: 18 }}>+</span>}
                        onClick={() => setShowConversationModal(true)}
                        className={classes.addConversationBtn}
                        disabled={loading || (remainingLaunches <= 0 && launchText)}
                    >
                        Add New Conversation
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setShowHistoryModal(true)}
                        className={classes.addConversationBtn}
                        disabled={!isFinalTransactionCompleted}
                    >
                        Conversation History
                    </Button>
                    <MUIIconButton
                        title="Download as PDF"
                        onClick={handleDownloadClick}
                        disabled={loading}
                        className={classes.downloadBtn}
                    >
                        <FontAwesomeIcon icon={faDownload} />
                    </MUIIconButton>
                </div>

                {/* Show full-area loader while fetching latest conversation on mount */}

                {noConversationRecords ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                        <Typography variant="h6" color="textSecondary">
                            No Conversation Records Available
                        </Typography>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "0.5rem",
                            "@media print": {
                                display: "block",
                                flexWrap: "unset",
                                gap: 0,
                            },
                        }}
                    >
                        {displayedTables.map((table) => (
                            <TableWrapper
                                key={table.id}
                                {...table}
                                loading={loading}
                                minWidth={tableFilter === 'both' ? "49%" : "100%"}
                                discoveryCtx={discoveryCtx}
                                selectedCategory={selectedCategory}
                                primaryLLM={primaryLLM}
                                primaryMarket={primaryMarket}
                                isPrimaryCategory={isPrimaryCategory}
                                type={type}
                            />
                        ))}
                    </Box>
                )}

                <div style={{ display: 'none' }}>
                    <div ref={pdfRef} style={{ width: '100%', maxWidth: '210mm', margin: '0 auto' }}>
                        <div style={{ padding: '8mm' }}>

                            {/* ===== PDF HEADER (ONLY FIRST PAGE) ===== */}
                            <div
                                style={{
                                    pageBreakAfter: 'avoid',
                                    breakAfter: 'avoid',
                                    pageBreakInside: 'avoid',
                                    breakInside: 'avoid',
                                    marginBottom: '4px',
                                    paddingBottom: '0',
                                }}
                            >
                                <h1
                                    style={{
                                        textAlign: 'center',
                                        margin: '0 0 6px 0',
                                        fontSize: '18px',
                                        color: '#1f2937',
                                        pageBreakAfter: 'avoid',
                                        breakAfter: 'avoid'
                                    }}
                                >
                                    {pdfFilterOption === getEntityLabel(discoveryCtx?.type).toLowerCase() && `${getEntityLabel(discoveryCtx?.type)} Conversations Report`}
                                    {pdfFilterOption === 'category' && 'Category Conversations Report'}
                                    {pdfFilterOption === 'both' && `${getEntityLabel(discoveryCtx?.type)} and Category Conversations Report`}
                                </h1>

                                <div
                                    style={{
                                        margin: '0',
                                        textAlign: 'center',
                                        color: '#6b7280',
                                        fontSize: '10px',
                                        lineHeight: '1.3'
                                    }}
                                >
                                    <p style={{ margin: '2px 0' }}>
                                        <strong>Entity:</strong> {discoveryCtx.entity} |{" "}
                                        <strong>Type:</strong> {getEntityLabel(discoveryCtx?.type)} |{" "}
                                        <strong>Category:</strong> {selectedCategory} |{" "}
                                    </p>

                                    <p style={{ margin: '2px 0' }}>
                                        <strong>Persona:</strong>{" "}
                                        {conversationSelection?.persona?.title || conversationSelection?.persona} |{" "}
                                        <strong>Market:</strong> {conversationSelection?.market} |{" "}
                                    </p>

                                    <p style={{ margin: '2px 0' }}>
                                        <strong>Filter:</strong>{" "}
                                        {pdfFilterOption.charAt(0).toUpperCase() + pdfFilterOption.slice(1)}
                                    </p>
                                </div>
                            </div>

                            {/* ===== END HEADER ===== */}

                            {getFilteredTables().map((table, index) => (
                                // <div
                                //     key={table.id}
                                //     style={{
                                //         marginBottom: '8px',
                                //         pageBreakInside: 'avoid',
                                //         breakInside: 'avoid'
                                //     }}
                                // >
                                <div
                                    key={table.id}
                                    style={{
                                        marginBottom: "6px",
                                        pageBreakInside: index === 0 ? "auto" : "avoid",
                                        breakInside: index === 0 ? "auto" : "avoid",
                                    }}
                                >
                                    <TableWrapper
                                        {...table}
                                        isFirstPdfTable={index === 0}
                                        loading={false}
                                        minWidth="100%"
                                        discoveryCtx={discoveryCtx}
                                        selectedCategory={selectedCategory}
                                        primaryLLM={primaryLLM}
                                        primaryMarket={primaryMarket}
                                        isPrimaryCategory={isPrimaryCategory}
                                        type={type}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
            {showShareModal &&
                <Modal
                    height="60%"
                    title="Share Link"
                    open={showShareModal}
                    handleClose={() => setShowShareModal(false)}
                >
                    <Share setShowShareModal={setShowShareModal} />
                </Modal>
            }
            {showConversationModal && (
                <Modal
                    open={showConversationModal}
                    handleClose={() => setShowConversationModal(false)}
                    title="New Conversation"
                >
                    <ConversationForm
                        onGenerate={onGenerate}
                        loading={false}
                    />
                </Modal>
            )}
            {showHistoryModal && (
                <Modal
                    open={showHistoryModal}
                    handleClose={() => setShowHistoryModal(false)}
                    title="Conversation History"
                    width="600px"
                    height="50%"
                >
                    <ConversationHistory
                        transactionId={transactionId}
                        requestId={requestId}
                        getConversationData={getConversationData}
                        activeConversationId={activeConversationId}
                        onAfterDelete={handleAfterDelete}
                    />
                </Modal>
            )}
            {/* PDF Filter Modal */}
            <PdfFilterModal
                open={showPdfFilterModal}
                onClose={handlePdfModalClose}
                pdfFilterOption={pdfFilterOption}
                onFilterChange={handlePdfFilterChange}
                onDownload={handlePdfDownload}
                pdfFilterOptions={pdfFilterOptions}
            />
        </>
    );
};

export default Conversations;